import { GcpTypography } from '@back-office/ui';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { observer } from 'mobx-react';
import React, { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  tabs: {
    boxShadow: '0px -1px 0px 0px #F0F0F0 inset',
  },
  tab: {
    minWidth: 'initial',
    '> .MuiTab-root': {
      textTransform: 'unset',
    },
  },
  selectedTab: {
    color: `${theme.palette.secondary.main} !important`,
  },
}));

interface TabsPaymentFileProps {
  value: number;
  items: string[];
  handleChange: (event: ChangeEvent<unknown>, newValue: number) => void;
}

const TabsPaymentFile: FC<TabsPaymentFileProps> = observer((props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { value, items, handleChange } = props;

  return (
    <Tabs
      className={classes.tabs}
      indicatorColor="secondary"
      value={value}
      onChange={handleChange}
    >
      {items.map((item, index) => (
        <Tab
          key={item}
          className={`${classes.tab}`}
          label={
            <GcpTypography
              className={` ${value === index ? classes.selectedTab : ''}`}
            >
              {t(`payment_file.tabs.${item}`)}
            </GcpTypography>
          }
        />
      ))}
    </Tabs>
  );
});

export default TabsPaymentFile;
